import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.index-of";
import _values from "lodash/values";
import _isNil from "lodash/isNil";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { colors } from '@nerdwallet/base-styles/variables';
import { getLegacyId } from '@nerdwallet/marketplace/selectors/common';
import MarketplaceApplyNow, { APPLY_NOW_LINK_TYPES, LINK_TYPES, APPLY_NOW_FINISH_TYPES } from '@nerdwallet/react-marketplace-apply-now';
import { CONTENT_TABS, PREHEADER_TYPE, SENTIMENT_TYPE, TRK_PRODUCT_LOCATION } from '../lib/constants';
import { buildTrkSectionCategory, getMonetizable } from '../lib/utils';
import Content from '../content';
import Drivers from '../drivers';
import KetoProductCardHeader from './keto-header';
import KetoImageAndRating from './keto-image-rating-wrapper';
import KetoAccordion from './accordion-content';
import KetoDrivers from './keto-drivers';
import Preheader from '../preheader';
import mapMarketplaceEntityToProps, { DRIVER_GROUPS } from '../mappings';
import styles from './keto-product-card.module.less';
import ProductCardImageWrapper from '../product-card-image-wrapper';
export var BaseKetoProductCard = function BaseKetoProductCard(_ref) {
  var _analytics$productImp, _analytics$productImp2, _analytics$productImp3, _analytics$productImp4, _analytics$productImp5, _analytics$productImp6, _ref2;

  var analytics = _ref.analytics,
      bottomLine = _ref.bottomLine,
      className = _ref.className,
      cons = _ref.cons,
      ctaHref = _ref.ctaHref,
      ctaShowIcon = _ref.ctaShowIcon,
      ctaSubtext = _ref.ctaSubtext,
      ctaText = _ref.ctaText,
      drivers = _ref.drivers,
      forceMobile = _ref.forceMobile,
      heading = _ref.heading,
      identity = _ref.identity,
      imageData = _ref.imageData,
      initAccordionItemExpanded = _ref.initAccordionItemExpanded,
      marketplaceEntity = _ref.marketplaceEntity,
      marketplaceEntitySlug = _ref.marketplaceEntitySlug,
      omitCta = _ref.omitCta,
      omitRating = _ref.omitRating,
      omitRatingTextHref = _ref.omitRatingTextHref,
      productDetails = _ref.productDetails,
      productType = _ref.productType,
      pros = _ref.pros,
      reviewLinkHref = _ref.reviewLinkHref,
      secondaryCtaHref = _ref.secondaryCtaHref,
      secondaryCtaText = _ref.secondaryCtaText,
      shouldLogImpression = _ref.shouldLogImpression,
      starRating = _ref.starRating,
      taxonomy = _ref.taxonomy,
      trkPageType = _ref.trkPageType,
      trkProductPosition = _ref.trkProductPosition,
      trkSectionCategory = _ref.trkSectionCategory,
      wrapDrivers = _ref.wrapDrivers,
      _handleCcCompareClick = _ref._handleCcCompareClick,
      _hasCcCompareButton = _ref._hasCcCompareButton,
      _compareCards = _ref._compareCards,
      hasPreheader = _ref.hasPreheader,
      preheaderHoverText = _ref.preheaderHoverText,
      preheaderSentiment = _ref.preheaderSentiment,
      preheaderText = _ref.preheaderText,
      preheaderType = _ref.preheaderType,
      preheaderUrl = _ref.preheaderUrl,
      showMatchScoreCTA = _ref.showMatchScoreCTA,
      isSelectedToCompare = _ref.isSelectedToCompare,
      displayPage = _ref.displayPage,
      showNotYetRated = _ref.showNotYetRated,
      checkboxLabel = _ref.checkboxLabel,
      enableAnalytics = _ref.enableAnalytics,
      lazyLoadEnabled = _ref.lazyLoadEnabled;
  var impressionContext = useContext(ImpressionContext);
  var productCardImage = /*#__PURE__*/React.createElement(ProductCardImageWrapper, {
    imageData: imageData,
    backgroundColor: colors.transparent,
    imageClassName: styles.productImage,
    className: styles.productImageWrapper,
    objectFit: "contain",
    lazyLoadEnabled: lazyLoadEnabled,
    isKetoCard: true
  });
  var legacyId = getLegacyId(marketplaceEntity);
  var mpcTrkSectionCategory = buildTrkSectionCategory(trkSectionCategory, TRK_PRODUCT_LOCATION); // The rates & fees link is populated in CC mapping into secondary Ctas

  var secondaryCtas = secondaryCtaText && secondaryCtaHref && /*#__PURE__*/React.createElement(MarketplaceApplyNow, {
    className: styles.secondaryCta,
    elementName: analytics === null || analytics === void 0 ? void 0 : (_analytics$productImp = analytics.productImpressionProps) === null || _analytics$productImp === void 0 ? void 0 : (_analytics$productImp2 = _analytics$productImp.payload) === null || _analytics$productImp2 === void 0 ? void 0 : _analytics$productImp2.element_name,
    finishType: APPLY_NOW_FINISH_TYPES.EXTERNAL_CONTENT,
    impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
    id: APPLY_NOW_LINK_TYPES.ratesAndFeesText,
    link: secondaryCtaHref,
    linkType: APPLY_NOW_LINK_TYPES.ratesAndFeesText,
    monetizable: getMonetizable(marketplaceEntity),
    marketplaceEntity: marketplaceEntity,
    sectionName: (analytics === null || analytics === void 0 ? void 0 : (_analytics$productImp3 = analytics.productImpressionProps) === null || _analytics$productImp3 === void 0 ? void 0 : (_analytics$productImp4 = _analytics$productImp3.payload) === null || _analytics$productImp4 === void 0 ? void 0 : _analytics$productImp4.section_name) || "keto_product_card",
    sectionPosition: analytics === null || analytics === void 0 ? void 0 : (_analytics$productImp5 = analytics.productImpressionProps) === null || _analytics$productImp5 === void 0 ? void 0 : (_analytics$productImp6 = _analytics$productImp5.payload) === null || _analytics$productImp6 === void 0 ? void 0 : _analytics$productImp6.section_position,
    type: LINK_TYPES.LINK,
    shouldLogImpression: shouldLogImpression
  }, secondaryCtaText); // get all the added cardIds from the compare bar

  var cardIDsToCompare = _get(_compareCards, 'cardIDsToCompare') || []; // if the boolean isSelectedToCompare is defined (true/false) we will use the value,
  // if not, we will cardIDsToCompare and check if the
  // card id already added in the cardIDsToCompare;
  // then display the checkbox checked=true

  var isInCompare = !_isNil(isSelectedToCompare) ? isSelectedToCompare : cardIDsToCompare.indexOf(legacyId) > -1;
  var productCardPreheader = hasPreheader ? /*#__PURE__*/React.createElement(Preheader, {
    className: styles.preheader,
    taxonomy: taxonomy,
    text: preheaderText,
    title: preheaderHoverText,
    trkPageType: trkPageType,
    sentiment: preheaderSentiment,
    type: preheaderType,
    url: preheaderUrl,
    isKetoCard: true
  }) : null;
  var isPreheaderBadge = preheaderType === PREHEADER_TYPE.BADGE;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([className, styles.ketoProductCardContainer, (_ref2 = {}, _defineProperty(_ref2, styles.ketoProductCardTopMargin, !isPreheaderBadge), _defineProperty(_ref2, styles.ketoProductCardContainerCheckBoxSelected, isInCompare), _defineProperty(_ref2, styles.forceMobile, forceMobile), _ref2)])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.ketoProductCardHeader
  }, /*#__PURE__*/React.createElement(KetoProductCardHeader, {
    className: hasPreheader ? styles.header : styles.headerWithNoPreHeader,
    heading: heading,
    marketplaceEntity: marketplaceEntity,
    marketplaceEntitySlug: marketplaceEntitySlug,
    productType: productType,
    reviewLinkHref: reviewLinkHref,
    shouldLogImpression: shouldLogImpression,
    taxonomy: taxonomy,
    trkPageType: trkPageType,
    trkProductPosition: trkProductPosition,
    trkSectionCategory: mpcTrkSectionCategory // compare button specific props
    ,
    _hasCcCompareButton: _hasCcCompareButton,
    _handleCcCompareClick: _handleCcCompareClick,
    checkboxLabel: checkboxLabel,
    isSelectedToCompare: isSelectedToCompare // BNK specific props
    ,
    displayPage: displayPage,
    hasPreheader: hasPreheader,
    productCardPreheader: productCardPreheader,
    isPreheaderBadge: isPreheaderBadge // bedrock
    ,
    enableAnalytics: (analytics === null || analytics === void 0 ? void 0 : analytics.enabled) || enableAnalytics
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.ketoBody
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.ketoImageAndRatingContainer
  }, /*#__PURE__*/React.createElement(KetoImageAndRating, {
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.imageAndRatingProps,
    productCardImage: productCardImage,
    ctaHref: ctaHref,
    ctaSubtext: ctaSubtext,
    enableAnalytics: enableAnalytics,
    imageData: imageData,
    id: "".concat(TRK_PRODUCT_LOCATION, "__product-button--under-image--").concat(trkProductPosition),
    identity: identity,
    marketplaceEntity: marketplaceEntity,
    marketplaceEntitySlug: marketplaceEntitySlug,
    productType: productType,
    secondaryCtas: secondaryCtas,
    ctaShowIcon: ctaShowIcon,
    ctaText: ctaText,
    omitRating: omitRating,
    omitRatingTextHref: omitRatingTextHref,
    starRating: starRating,
    reviewLinkHref: reviewLinkHref,
    omitCta: omitCta,
    shouldLogImpression: shouldLogImpression,
    taxonomy: taxonomy,
    trkPageType: trkPageType,
    trkProductPosition: trkProductPosition,
    trkSectionCategory: mpcTrkSectionCategory // BNK specific props
    ,
    displayPage: displayPage,
    showNotYetRated: showNotYetRated // CC specific props
    ,
    showMatchScoreCTA: showMatchScoreCTA
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.ketoProductCardDriversContent
  }, !!drivers && /*#__PURE__*/React.createElement(KetoDrivers, {
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.driverProps,
    className: styles.drivers,
    enableAnalytics: enableAnalytics,
    drivers: drivers,
    wrapDrivers: wrapDrivers
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.ketoProductCardAccordion
  }, /*#__PURE__*/React.createElement(KetoAccordion, {
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.accordionProps,
    bottomLine: bottomLine,
    cons: cons,
    enableAnalytics: enableAnalytics,
    initAccordionItemExpanded: initAccordionItemExpanded,
    productDetails: productDetails,
    pros: pros
  })));
};
BaseKetoProductCard.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, Content.propTypes), KetoProductCardHeader.propTypes), Drivers.propTypes), {}, {
  className: PropTypes.string,
  ctaHref: PropTypes.string,
  ctaShowIcon: PropTypes.bool,
  ctaSubtext: PropTypes.string,
  ctaText: PropTypes.string,
  displayPage: PropTypes.string,
  hasAccordionOnMobile: PropTypes.bool,
  // eslint-disable-line react/no-unused-prop-types
  imageData: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  initAccordionItemExpanded: PropTypes.bool,
  marketplaceEntity: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  marketplaceEntitySlug: PropTypes.string,
  omitCta: PropTypes.bool,
  omitRating: PropTypes.bool,
  omitRatingTextHref: PropTypes.bool,
  omitTabs: PropTypes.bool,
  // eslint-disable-line react/no-unused-prop-types
  omittedTabs: PropTypes.arrayOf(PropTypes.oneOf(_values(CONTENT_TABS))),
  // eslint-disable-line react/no-unused-prop-types
  productType: PropTypes.string,
  shouldLogImpression: PropTypes.bool,
  taxonomy: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  trkSectionCategory: PropTypes.string,
  // CC specific props
  identity: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  hasPreheader: PropTypes.bool,
  matchScore: PropTypes.number,
  // eslint-disable-line react/no-unused-prop-types
  preheaderHoverText: PropTypes.string,
  preheaderSentiment: PropTypes.oneOf(_values(SENTIMENT_TYPE)),
  preheaderText: PropTypes.string,
  preheaderType: PropTypes.oneOf(_values(PREHEADER_TYPE)),
  preheaderUrl: PropTypes.string,
  showMatchScoreCTA: PropTypes.bool,
  // MORTG specific props
  minCreditScoreType: PropTypes.string,
  // eslint-disable-line react/no-unused-prop-types

  /** Shows not yet rated component with empty star rating */
  showNotYetRated: PropTypes.bool,
  analytics: PropTypes.shape({
    productImpressionProps: PropTypes.shape({
      payload: PropTypes.shape({
        element_position: PropTypes.number,
        section_name: PropTypes.string,
        section_position: PropTypes.number
      })
    }),
    imageAndRatingProps: PropTypes.shape({
      entityName: PropTypes.string
    }),
    driverProps: PropTypes.shape({
      entityName: PropTypes.string
    }),
    accordionProps: PropTypes.shape({
      ourTakeProps: PropTypes.shape({
        entityName: PropTypes.string,
        sectionName: PropTypes.string,
        sectionPosition: PropTypes.number
      }),
      productDetailsProps: PropTypes.shape({
        entityName: PropTypes.string,
        sectionName: PropTypes.string,
        sectionPosition: PropTypes.number
      })
    }),
    payload: PropTypes.shape({
      elementName: PropTypes.string
    })
  })
});
BaseKetoProductCard.defaultProps = {
  displayPage: '',
  hasAccordionOnMobile: false,
  hasPreheader: false,
  initAccordionItemExpanded: false,
  preheaderSentiment: SENTIMENT_TYPE.NEUTRAL,
  preheaderType: PREHEADER_TYPE.PLAIN_TEXT,
  taxonomy: _get(global.window, 'nwPageTaxonomy'),
  preheaderHoverText: '',
  // CC specific props
  identity: {},
  showMatchScoreCTA: false,
  // Bedrock props
  analytics: {}
};
export var KetoProductCard = function KetoProductCard(props) {
  if (!props.marketplaceEntity) {
    return null;
  }

  var mappedProps = mapMarketplaceEntityToProps(_objectSpread(_objectSpread({}, props), {}, {
    isKetoCard: true
  }));
  return /*#__PURE__*/React.createElement(BaseKetoProductCard, mappedProps);
};
KetoProductCard.propTypes = {
  driverGroup: PropTypes.oneOf(_values(DRIVER_GROUPS)),
  marketplaceEntity: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  marketplaceEntitiesForCdApyTerms: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    oneYear: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    threeYear: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    fiveYear: PropTypes.object
  }),
  wrapDrivers: PropTypes.bool,
  hidePrequalCta: PropTypes.bool,
  // Keto Card specific props
  checkboxLabel: PropTypes.string,
  analytics: PropTypes.shape({
    productImpressionProps: PropTypes.shape({
      payload: PropTypes.shape({
        element_position: PropTypes.number,
        section_name: PropTypes.string,
        section_position: PropTypes.number
      })
    }),
    imageAndRatingProps: PropTypes.shape({
      entityName: PropTypes.string
    }),
    driverProps: PropTypes.shape({
      entityName: PropTypes.string
    }),
    accordionProps: PropTypes.shape({
      ourTakeProps: PropTypes.shape({
        entityName: PropTypes.string,
        sectionName: PropTypes.string,
        sectionPosition: PropTypes.number
      }),
      productDetailsProps: PropTypes.shape({
        entityName: PropTypes.string,
        sectionName: PropTypes.string,
        sectionPosition: PropTypes.number
      })
    }),
    prequalCTATrk: PropTypes.string,

    /** @deprecated Used by accordion */
    payload: PropTypes.shape({
      elementName: PropTypes.string
    })
  }),
  forceMobile: PropTypes.bool,
  lazyLoadEnabled: PropTypes.bool
};
KetoProductCard.defaultProps = {
  driverGroup: DRIVER_GROUPS.DEFAULT_DRIVER_GROUP,
  marketplaceEntitiesForCdApyTerms: {},
  wrapDrivers: false,
  // CC specific props
  hidePrequalCta: false,
  // analytics
  analytics: {},
  lazyLoadEnabled: false
};
KetoProductCard.displayName = 'KetoProductCard';